import React from 'react';
import SupportingToolsLayout from './SupportingToolsLayout';
import { LIVE } from './SupportingToolsContext';

// Supporting Tools Live: the screens moved out of Supporting Tools, behind their
// own route, module key and per-screen rights.
function SupportingToolsLiveLayout() {
  return <SupportingToolsLayout config={LIVE} />;
}

export default SupportingToolsLiveLayout;
